(() => {
  if (window.phTrustRatingsReady) return;
  window.phTrustRatingsReady = true;
  const update = async () => {
    const targets = document.querySelectorAll('.ph-trust__item--rating .ph-trust__copy, .ph-product-trust a:last-child > span:last-child, [data-ph-rating-summary]');
    if (!targets.length) return;
    try {
      const settings = JSON.parse(document.getElementById('oke-reviews-settings')?.textContent || '{}');
      if (!settings.subscriberId) return;
      const response = await fetch('https://api.okendo.io/v1/stores/' + encodeURIComponent(settings.subscriberId) + '/review_aggregate', {signal: AbortSignal.timeout(5000)});
      if (!response.ok) return;
      const {reviewAggregate: aggregate} = await response.json();
      const count = Number(aggregate?.reviewCount);
      const total = Number(aggregate?.reviewRatingValuesTotal);
      if (!Number.isInteger(count) || count <= 0 || !Number.isFinite(total) || total < count || total > count * 5) return;
      const rating = (total / count).toFixed(1);
      targets.forEach(target => {
        target.querySelector('strong').textContent = rating + '/5 customer rating';
        target.querySelector('.ph-trust__text, small').textContent = 'From ' + count.toLocaleString('en-GB') + ' customer ' + (count === 1 ? 'review' : 'reviews');
      });
    } catch {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true});
  else update();
  document.addEventListener('shopify:section:load', update);
})();